import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#legacy", label: "Legacy" },
  { href: "#training", label: "Training" },
  { href: "#coach", label: "Coach" },
  { href: "#gallery", label: "Gallery" },
  { href: "#timetable", label: "Timetable" },
  { href: "#membership", label: "Membership" },
  { href: "#booking", label: "Book" },
  { href: "#shop", label: "Shop" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_fullcircle-mma/artifacts/hpytiapw_Copilot_20260501_123104.png"
            alt="Full Circle MMA"
            className="h-10 md:h-11 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-xs uppercase tracking-[0.18em] text-white/80 hover:text-[#d4af37] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          data-testid="nav-cta-book"
          className="hidden md:inline-flex items-center px-5 py-2.5 bg-[#d4af37] text-black text-xs font-bold uppercase tracking-[0.18em] hover:bg-[#f1c40f] transition-colors btn-lift"
        >
          Book Now
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl">
          <div className="flex flex-col p-6 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.18em] text-white/80 hover:text-[#d4af37]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#booking"
              data-testid="mobile-nav-cta"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#d4af37] text-black text-xs font-bold uppercase tracking-[0.18em]"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
